import { useState } from "react";

import { useAppDispatch } from "../redux";
import { useCreateDownloadReportJobMutation, addDownloadJob, updateDownloadJobStatus } from "../redux/reducers/downloadJobs.reducer";
import { useNotification } from "../components/FeedbackNotification/useNotification";
import downloadServices from "../redux/services/download.services";
import { ICreateReportJobRequestData } from "../types";

export function useDownloadJob() {
	const dispatch = useAppDispatch();
	const { notify } = useNotification();

	const [isLoading, setIsLoading] = useState<boolean>(false);

	const [createDownloadReportJob] = useCreateDownloadReportJobMutation();

	function handleDownloadReport(jobID: string) {
		downloadServices
			.handleDownloadReport(jobID)
			.then(() => {
				dispatch(
					updateDownloadJobStatus({
						jobId: jobID,
						status: "completed",
						progress: 100,
						message: "Download complete",
						error: ""
					})
				);
			})
			.catch((error) => {
				dispatch(
					updateDownloadJobStatus({
						jobId: jobID,
						status: "failed",
						error: typeof error === "string" ? error : String(error ?? "Download failed")
					})
				);
			});
	}

	function startDownload(options: ICreateReportJobRequestData) {
		setIsLoading(true);

		createDownloadReportJob(options)
			.unwrap()
			.then((response) => {
				if (response.file_exists) {
					handleDownloadReport(response.job_id);
					setIsLoading(false);
					return;
				}

				dispatch(
					addDownloadJob({
						response,
						reportType: options.report_type
					})
				);

				dispatch(
					updateDownloadJobStatus({
						jobId: response.job_id,
						status: "pending",
						message: "Starting download..."
					})
				);

				setIsLoading(false);
			})
			.catch((error) => {
				notify(typeof error?.data === "string" ? error.data : String(error?.data ?? "Something went wrong"), "error");
				setIsLoading(false);
			});
	}

	return {
		isLoading,
		startDownload
	};
}

